<template>
<div class="mobile">
    <header class="header">
       <img src="~@/assets/images/mobilelogin/banner.png" alt="">
    </header>
    <section class="section">
        <form class="form" v-show="loginInfo">
            <div class="form-list">
                <label for="tab" class="tab">手机号码</label>
                <el-dropdown class="my-el-dropdown" placement="bottom-start" trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                    {{dropdownDefault}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="my-dropdown1">
                    <el-dropdown-item class="my-el-dropdown-item"
                    v-for="(item,index) in dropdownList" :key="index" :command="item.en">
                    <p>{{item.zh}}</p>
                    <p>{{item.en}}</p>
                    </el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
                <input type="text" id="tal" v-model="tal" placeholder="输入手机号"/>
            </div>
            <div class="form-list">
                <label for="pass">密码</label>
                <input :type="passType" id="pass" v-model="pass" placeholder="输入密码"/>
                <img src="~@/assets/images/mobilelogin/icon2.png" alt="" class="icon1" v-if="passType=='password'" @click="showPwd">
                <img src="~@/assets/images/mobilelogin/icon3.png" alt="" class="icon2" v-if="passType=='text'"  @click="showPwd">
            </div>
            <p class="forgot-pass" @click="forgotPwd">忘记密码?</p>
            <p class="error-msg">{{errorMessage}}</p>
            <div class="login-btn" @click="loginHandler">登 录</div>
        </form>

        <!-- 更改密码 -->
        <form class="form" v-show="pwdInfo">
            <div class="form-list">
                <label for="tal">手机号码</label>
                <el-dropdown class="my-el-dropdown" placement="bottom-start" trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                    {{dropdownDefault}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="my-dropdown1">
                    <el-dropdown-item class="my-el-dropdown-item"
                    v-for="(item,index) in dropdownList" :key="index" :command="item.en">
                    <p>{{item.zh}}</p>
                    <p>{{item.en}}</p>
                    </el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
                <input type="text" id="tal" v-model="formquery.tal" placeholder="输入手机号"/>
            </div>
            <div class="form-list">
                <label for="pwd">验证码</label>
                <input type="text" v-model="formquery.pwd" placeholder=""/>
                <span class="get-code" @click="requestVerificationCode">{{codeBtnText}}</span>
            </div>
            <div class="form-list">
                <label for="passwd1">设置密码</label>
                <input :type="passwd1" id="passwd1" v-model="formquery.passwd1" placeholder=""/>
                <img src="~@/assets/images/mobilelogin/icon2.png" alt="" class="icon1" 
                v-if="passwd1 =='password'" @click="checkpwd1">
                <img src="~@/assets/images/mobilelogin/icon3.png" alt="" class="icon2" v-if="passwd1 =='text'" @click="checkpwd1">
            </div>
            <div class="form-list">
                <label for="passwd2">确认密码</label>
                <input :type="passwd2" id="passwd2" v-model="formquery.passwd2" placeholder=""/>
                 <img src="~@/assets/images/mobilelogin/icon2.png" alt="" class="icon1" v-if="passwd2 =='password'" @click="checkpwd2">
                <img src="~@/assets/images/mobilelogin/icon3.png" alt="" class="icon2" v-if="passwd2 =='text'" @click="checkpwd2">
            </div>
            <p class="error-msg">{{error}}</p>
            <div class="login-btn" @click="ChangesLogin">确认修改</div>
        </form>
    </section>
</div>
</template>
<script>
import '../../config/rem.js'
export default {
    data() {
        return {
            loginInfo: true,
            pwdInfo: false,
            tal: "", // 手机号
            pass: "", // 密码
            passType: 'password', // 密码类型
            errorMessage: "",
            error: "",
            dropdownDefault: "+86",
            dropdownList: [
                { zh: "中国大陆", en: "+86" },
                { zh: "中国香港", en: "+852" },
                { zh: "中国澳门", en: "+853" },
                { zh: "中国台湾", en: "+886" },
                { zh: "日本", en: "+81" },
                { zh: "韩国", en: "+82" },
                { zh: "美国", en: "+1" },
                { zh: "加拿大", en: "+1" },
                { zh: "英国", en: "+44" },
                { zh: "法国", en: "+33" },
                { zh: "德国", en: "+49" },
                { zh: "俄罗斯", en: "+7" },
                { zh: "西班牙", en: "+34" },
                { zh: "新加坡", en: "+65" },
                { zh: "马来西亚", en: "+60" },
                { zh: "泰国", en: "+66" },
                { zh: "印度", en: "+91" },
                { zh: "澳大利亚", en: "+61" },
                { zh: "新西兰", en: "+64" }
            ],
            formquery:{
                tal:"", // 手机哈
                pwd: "", // 验证码
                passwd1: "", // 设置验证码
                passwd2: "", // 确定验证码
            },
            codeBtnText: "获取验证码",
            timer: null, // 清空计时器
            passwd1: "password",
            passwd2: "password"
        }
    },
    methods: {
        handleCommand(command) {
            this.dropdownDefault = command;
        },
        // 切换密码可显
        showPwd(){
            this.passType = this.passType == "password" ? "text" :"password";
        },
        // 忘记密码
        forgotPwd(){
            this.loginInfo = false;
            this.pwdInfo = true;
        },
        checkpwd1(){
            this.passwd1 = this.passwd1 == "password" ? "text" :"password";
        },
        checkpwd2(){
            this.passwd2 = this.passwd2 == "password" ? "text" :"password";
        },
        loginHandler () {
            if(this.tal == "" || this.pass == ""){
                this.errorMessage = "用户名和密码不能为空";
                return;
            }
            // var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
            // if (!myreg.test(this.tal)) {
            //   this.errorMessage = "手机号填写有误"
            //   return;
            // }
            this.errorMessage = "";

            this.axios.post("/signin.json",{
                // mobile: this.tal.trim(),
                mobile: `${this.dropdownDefault}-${this.tal.trim()}`,
                passwd: this.pass
            }).then((res) => {
                // window.location('/', '_self');
                this.$router.push("/classlist");
            }).catch((error) => {
                if (error.response) {
                    let data = error.response.data;
                    this.errorMessage = data.error.message;
                } 
            });
        },
        // 修改登录
        ChangesLogin () {
            if(this.formquery.tal == "" || this.formquery.pwd == "" || this.formquery.passwd1 == "" || this.formquery.passwd2 == ""){
              this.error = "每一项都需要填写";
              return;
            }
            var myreg=/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.formquery.tal)) {
              this.error = "手机号填写有误";
              return;
            }

            if(this.formquery.passwd1.length < 6 || this.formquery.passwd1.length > 12){
              this.error = "密码长度应该在6-12之间";
              return;
            }

            if(this.formquery.passwd1 !== this.formquery.passwd2){
              this.error = "两次输入密码不一致";
              return;
            }
            this.error = "";
            clearInterval(this.timer);
            this.axios.post("/forgotpasswd.json",{
              'mobile': `${this.dropdownDefault}-${this.formquery.tal.trim()}`,
              'verification-code': this.formquery.pwd,
              'passwd': this.formquery.passwd1,
              'passwdrepeat': this.formquery.passwd2,
            }).then((res) => {
              // window.open('/', '_self');
              this.$router.push("/classlist");
            }).catch((error) => {
              if (error.response) {
                let data = error.response.data;
                this.error = data.error.message;
              } 
            });
        },
        // 获取验证码
        requestVerificationCode () {
          if(this.codeBtnText !== "获取验证码"){
            return;
          }
          // var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
          // if (!myreg.test(this.tal)) {
          //   this.errorMessage = "手机号填写有误";
          //   return;
          // }
          this.error = "";
          this.axios.post("/verifycode",{
            phone: `${this.dropdownDefault}-${this.formquery.tal.trim()}`,
          }).then((res) => {
            let time = 60;
            let _timer = this.timer;
            this.codeBtnText = "发送成功(60s)";
            clearInterval(_timer);
            _timerr = setInterval(() => {
              time--;
              if(time < 0){
                this.codeBtnText = "获取验证码";
                clearInterval(_timer);
              }else{
                this.codeBtnText = `发送成功(${time}s)`;
              }
            }, 1000);
          }).catch((error) => {
            console.log(error)
            if (error.response) {
              let data = error.response.data;
              this.error = data.error.message;
            } 
          });
        }
    }
}
</script>

<style scoped lang="scss">
// 横屏
.my-el-dropdown{
  // position: relative;
}
.my-el-dropdown-item{
  display: flex;
  justify-content: space-between;
}
// .my-dropdown{
//   width: 320px;
//   height: 300px;
//   overflow: auto;
// }
.my-dropdown1{
    width: 15rem;
    height: 15rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.15);
    border-radius: 12px;
    overflow: auto;
}
.my-dropdown1 .el-dropdown-menu__item p{
    font-size: .7rem;
}
.my-dropdown1 .el-dropdown-menu__item p:last-child{
    color: #FF911B;
}
.el-dropdown-menu__item{
    line-height: 1.5rem;
}
.mobile{
    width: 100%;
    height: 100%;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    .header{
        width: 100%;
        height: 10rem;
        img{
            height: 10rem;
        }
    }
    .section{
        width: 100%;
        height: auto;
        padding-top: .2rem;
        .form{
            width: 90%;
            margin: 0 auto;
            .form-list{
                width: 100%;
                height: 2.5rem;
                border-bottom: 1px solid #ccc;
                display: flex;
                justify-content: space-between;
                align-items: center;
                label{
                    display: inline-block;
                    width: 4rem;
                    font-size: .7rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }
                .el-dropdown-link{
                    font-size: .8rem;
                }
                .get-code{
                    display: inline-block;
                    width: 8rem;
                    text-align: center;
                    font-size: .75rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FDAC1C;
                }
                .tab{
                    position: relative;
                    &::after{
                        content: "";
                        width: 1px;
                        height: .8rem;
                        background: #ccc;
                        position: absolute;
                        right: .8rem;
                        top: 0;
                    }
                }
                input{
                    flex: 1;
                    height: 1rem;
                    border: none;
                    outline: none;
                    font-size: .8rem;
                    &::-webkit-input-placeholder{
                        font-size: .7rem;
                        color: #ccc;
                    }
                }
                img{
                    width: 1rem;
                }
            }
            .forgot-pass{
                font-size: .7rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: right;
                color: #FF8300;
                cursor: pointer;
                padding-top: .5rem;
            }
            .error-msg{
                font-size: .8rem;
                color: red;
                text-align: center;
                padding-top: .5rem;
            }
            .login-btn{
                width: 100%;
                height: 2.4rem;
                line-height: 2.4rem;
                background: #FDAC1C;
                border-radius: 1.2rem;
                text-align: center;
                background: #FDAC1C;
                margin: 1rem auto 0px;
                cursor: pointer;  
                font-size: 1rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                text-shadow: 0px 0px 4px rgba(189, 93, 0, 0.5);
            }
        }
    }
}

/* 其他pad屏幕尺寸 */
@media only screen and (min-width: 1200px){
    .mobile{
        position: relative;
        .header{
            width: 100%;
            height: 6rem;
            img{
                width: 100%;
                height: 6rem;
            }
        }
        .section{
            width: 100%;
            height: auto;
            padding-top: .1rem;
            padding-bottom: 1rem;
            .form{
                width: 90%;
                margin: 0 auto;
                .form-list{
                    width: 100%;
                    height: 1.5rem;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    label{
                        display: inline-block;
                        width: 2.5rem;
                        font-size: .5rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }
                    .el-dropdown-link{
                        font-size: .4rem;
                    }
                    .get-code{
                        display: inline-block;
                        width: 4rem;
                        text-align: center;
                        font-size: .5rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FDAC1C;
                    }
                    .tab{
                        position: relative;
                        &::after{
                            content: "";
                            width: 1px;
                            height: .6rem;
                            background: #ccc;
                            position: absolute;
                            right: .3rem;
                            top: 0;
                        }
                    }
                    input{
                        flex: 1;
                        height: 1rem;
                        border: none;
                        outline: none;
                        font-size: .5rem;
                        &::-webkit-input-placeholder{
                            font-size: .5rem;
                            color: #ccc;
                        }
                    }
                    img{
                        width: 1rem;
                    }
                }
                .forgot-pass{
                    font-size: .5rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    text-align: right;
                    color: #FF8300;
                    cursor: pointer;
                    padding-top: .2rem;
                }
                .error-msg{
                    font-size: .5rem;
                    color: red;
                    text-align: center;
                    padding-top: .2rem;
                }
                .login-btn{
                    width: 100%;
                    height: 1.6rem;
                    line-height: 1.6rem;
                    background: #FDAC1C;
                    border-radius: .8rem;
                    text-align: center;
                    background: #FDAC1C;
                    margin: .5rem auto;
                    cursor: pointer;  
                    font-size: .7rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    text-shadow: 0px 0px 4px rgba(189, 93, 0, 0.5);
                }
            }
        }
    }
    .my-dropdown1{
        width: 7rem;
        height: 7rem;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.15);
        border-radius: 12px;
        overflow: auto;
    }
    .my-dropdown1 .el-dropdown-menu__item p{
        font-size: .3rem
    }
    .my-dropdown1 .el-dropdown-menu__item p:last-child{
        color: #FF911B;
    }
    .el-dropdown-menu__item{
        line-height: .6rem;
    }
}
</style>